import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import SingleSignOnConfiguration from 'components/settings/singleSignOn/components/SingleSignOnConfiguration';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <SingleSignOnConfiguration {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}
